import { useEffect, useMemo } from 'react';
import LeasedFiberMapComponent from './leasedFiber_map.component';
import { useNavigate } from 'react-router-dom';

export const LeasedFiberMainComponent = () => {
  const navigate = useNavigate();
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('Leased Fiber Pair')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  return <LeasedFiberMapComponent />;
};
